import { inject } from '@angular/core';
import { CanActivateFn, UrlTree, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { UserService } from '../panelclient/services/user.service';

export const guardClinicorp: CanActivateFn = async (
  route,
  state
): Promise<boolean | UrlTree> => {
  const userService = inject(UserService);
  const router = inject(Router);

  try {
    const response = await firstValueFrom(userService.getConfigUser());

    if (!response?.configUser?.clinicorpMenu) {
      return router.createUrlTree(['app', 'perfil']);
    }

    return true;
  } catch (error) {
    return router.createUrlTree(['app', 'perfil']);
  }
};
